import tutorialCategoryApi from '../../../api/tutorialCategory';

const defaultState = () => ({
    tutorialCategoryResults: [],
    tutorialCategoryPagination: '',
    responSukses: '',
    konfirmResponse: {},
    alertMultiple: [],
    alert: ''
});

const state = defaultState();

const getters = {

};

const mutations = {

    listTutorialCategory(state, data) {
        state.tutorialCategoryResults = data.data.map((el) => {
            if (el.tutorial_category_status == "1") {
                el.tutorial_category_status = true
            } else {
                el.tutorial_category_status = false
            }
            return el
        });
        state.tutorialCategoryPagination = data.pagination;
    },
    konfirmasiSukses(state, data) {
        state.konfirmResponse = {};
        state.responSukses = data;
    },
    saveConfirmResponse(state, data) {
        state.konfirmResponse = data;
    },
    multipleAlert(state, data) {
        state.alertMultiple = data.map((el) => {
            return {
                show: true,
                message: el
            }
        })
    },
    failed(state, data) {
        state.alert = data
    },
    clearDataTutorialCategory(state) {
        Object.assign(state, defaultState());
    },
};

const actions = {
    getTutorialCategory({ commit }, param) {
        tutorialCategoryApi.getDataTutorialCategory(param).then(({ data: { data } }) => {
            commit('listTutorialCategory', { data: data.results, pagination: data.pagination });
        }).catch(() => {
            commit('listTutorialCategory', { data: [], pagination: {} });
        });
    },
    async addTutorialCategory({ dispatch, commit }, value) {
        commit("konfirmasiSukses", '');
        await tutorialCategoryApi.addTutorialCategory(value).then( res => {
            const data = res.data;
            dispatch('success', data)
            commit("konfirmasiSukses", data);
        })
        .catch(err => {
            const data = err.response.data
            dispatch("errorHandler", data)
            commit('setSnackbar', {
                show: true,
                color: 'red darken-2',
                text: 'Gagal menambah Kategori Tutorial'
            }, { root: true });
        });
    },
    async updateTutorialCategory({ dispatch, commit }, value) {
        commit("konfirmasiSukses", '');
        await tutorialCategoryApi.updateTutorialCategory(value).then( res => {
            const data = res.data;
            dispatch('success', data)
            commit("konfirmasiSukses", data);
        })
        .catch(err => {
            const data = err.response.data
            dispatch("errorHandler", data)
            commit('setSnackbar', {
                show: true,
                color: 'red darken-2',
                text: 'Gagal mengubah Kategori Tutorial'
            }, { root: true });
        });
    },
    async deleteTutorialCategory({ dispatch, commit }, value) {
        commit("konfirmasiSukses", '');
        await tutorialCategoryApi.deleteTutorialCategory({ id: value }).then( res => {
            const data = res.data;
            dispatch('success', data)
            commit("konfirmasiSukses", data);
        })
        .catch(err => {
            const data = err.response.data
            dispatch("errorHandler", data)
            commit('setSnackbar', {
                show: true,
                color: 'red darken-2',
                text: data.message
            }, { root: true });
        });
    },
    async statusTutorialCategory({ dispatch, commit }, value) {
        commit("konfirmasiSukses", '');
        await tutorialCategoryApi.statusTutorialCategory(value).then( res => {
            const data = res.data;
            dispatch('success', data)
            commit("konfirmasiSukses", data);
        })
        .catch(err => {
            const data = err.response.data
            dispatch("errorHandler", data)
            commit('setSnackbar', {
                show: true,
                color: 'red darken-2',
                text: 'Gagal mengubah status Kategori Tutorial'
            }, { root: true });
        });
    },
    success({ commit }, data) {
        commit('setSnackbar', {
            show: true,
            color: 'green accent-4',
            text: data.message
        }, { root: true });
    },
    errorHandler({ commit }, response) {
        switch (response.message) {
            case 'error_validation':
            commit('saveConfirmResponse', response.data);
            break;

            case 'error_multiple_alert':
            commit('multipleAlert', response.data.error)
            break;

            default:
            commit('failed', { code: 'error_response', type: 'error', message: response.message });
            break;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};